import { createMetricsFactory } from 'metrics-js';
export const EditorMetricsTracker = createMetricsFactory('EditorMetrics');